export default {"src":"/_next/static/media/missing-profile-image-plus.5924b6d9.svg","height":97,"width":97};